<template>
  <div>
    <mdb-tbl class="ml-3 my-2 fsize-m" sm >
      <mdb-tbl-head>
        <tr class="">
          <th>과목명</th>
          <th>시간</th>
          <th>단위수</th>
          <th>시작일</th>
          <th>종료일</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(s, i) in subjects" :key="i">
          <td class="pointer" @click="$emit('edit', s)"><mdb-icon icon="chalkboard-teacher" /> {{s.name}}</td>
          <td>{{s.totalHours}}</td>
          <td>{{s.lectures.length}}</td>
          <td>{{startDate(s)}}</td>
          <td>{{endDate(s)}}</td>
        </tr>
      </mdb-tbl-body>
      <add-btn-sm @click="onAddSubject">과목 추가</add-btn-sm>
    </mdb-tbl>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
import Subject from '@/models/Subject'
export default {
  name: 'SubjectsStructure',
  components: { mdbTbl, mdbTblHead, mdbTblBody },
  props: ['subjects'],
  data: () => ({
  }),
  methods: {
    onAddSubject () {
      const subject = Subject.create('NONNCS', this.$route.query.training)
      this.$emit('edit', subject)
    },
    startDate (subject) {
      if (subject.lectures) {
        return this.$strDate(subject.lectures[0].startDate)
      }
    },
    endDate (subject) {
      if (subject.lectures) {
        return this.$strDate(subject.lectures[subject.lectures.length - 1].startDate)
      }
    }
  }
}
</script>
